const preloadingComponents = (state: AnyFixMe) => state.preloadings;
const isComponentPreloading = (state: AnyFixMe, component: AnyFixMe) =>
  preloadingComponents(state).find(
    (comp: AnyFixMe) => comp.id === component.id,
  );

export { preloadingComponents, isComponentPreloading };
